import React, { useState, useEffect } from "react";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { setPaginationStatus } from "./utils/paginationUtil";
import Toggle from "@atlaskit/toggle";
const PaginationStatus = ({ action }) => {
  const [enabled, setEnabled] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (action && action.pagination) {
      setEnabled(action.pagination.enabled);
    } else {
      setEnabled(false);
    }
  }, [action]);
  const onChange = () => {
    setEnabled(!enabled);
    action.pagination = setPaginationStatus(action.pagination, !enabled);
    dispatch(setEditorSaved(false));
  };
  return (
    <>
      <Toggle id="toggle-large" size="large" isChecked={enabled} onChange={onChange} />
    </>
  );
};

export default PaginationStatus;
